module.exports = __webpack_public_path__ + "assets/persona_Portrait_1080x1920.png";


//////////////////
// WEBPACK FOOTER
// ./images/ai-preview/persona_Portrait_1080x1920.png
// module id = 706
// module chunks = 0